import { getJson } from './baseApi'

export const fetchGovernmentDepartments = () => {
	return getJson('/api/verification/governmentDepartments')
}